export abstract class ISearchersStrategyService {
    abstract mapSearchersToDashboard(): {
      predefinedSearchers?: { [key: string]: string };
      brand?: string;
    };
}
